import React, { useMemo } from 'react'
import { Flex, Spin } from 'antd'
import SubmissionsGroupCard from './SubmissionsGroupCard'
import useSubmissionGroups from './useSubmissionGroups'
import { useAutoOpenSubmissionFromParams } from '../../../../../store/apis/utils/hooks/text-submission.hooks'

const SubmissionGroupsSection = () => {
    const { groups, isFetching, totalSubmissions, isPendingTransition } = useSubmissionGroups()

    const submissionGroupCards = useMemo(
        () =>
            groups.map(group => (
                <SubmissionsGroupCard
                    key={group.id}
                    id={group.id}
                    title={group.title}
                    colorId={group.colorId}
                    totalSubmissions={totalSubmissions}
                    submissions={group.submissions}
                />
            )),
        [groups, totalSubmissions],
    )

    useAutoOpenSubmissionFromParams(groups)

    return (
        <Spin spinning={isFetching} tip='Loading submissions...'>
            <Flex gap={16} vertical className='clusters__container' style={{ opacity: isPendingTransition ? 0.5 : 1 }}>
                {submissionGroupCards}
            </Flex>
        </Spin>
    )
}

export default SubmissionGroupsSection
